const alphaDecor = {
  fa: {
    header: {
      title: "آلفا دکور",
      intro:
        "آلفا دکور یک وب‌سایت معرفی خدمات دکوراسیون داخلی است که با تمرکز بر طراحی ساده و مدرن، نمایش مناسب تصاویر و تجربه کاربری روان طراحی و توسعه داده شده است.",
      description: [
        "این پروژه با استفاده از ری‌اکت ساخته شده و ساختار آن بر پایه اجزای مستقل و قابل مدیریت شکل گرفته است. در کنار طراحی ظاهری، سازگاری صفحه با اندازه‌های مختلف نمایشگر نیز از ابتدا مورد توجه قرار گرفت.",

        "یکی از چالش‌های اصلی پروژه، ایجاد تعادل میان تصاویر، محتوا و چیدمان صفحه در اندازه‌های مختلف بود؛ به‌طوری که ساختار و ظاهر سایت در نمایشگرهای بزرگ و موبایل همچنان منسجم و کاربردی باقی بماند.",
      ],
      image: "imgs/ProjectRecords/alpha-decor/hero.webp",
    },
    side: {
      Project: "Alpha Decor",
      LiveDemo: "/alpha-decor",
      Language: "فارسی",
      Date: "مرداد ۱۴۰۵",
      Technologies:
        "React · JavaScript · HTML · CSS · Responsive Design · Flexbox · CSS Grid",
    },
  },

  en: {
    header: {
      title: "Alpha Decor",
      intro:
        "Alpha Decor is a modern website designed to showcase interior design services with a clean visual style, strong imagery, and a smooth user experience.",
      description: [
        "Built with React, the project focuses on component-based development, responsive layouts, and maintaining a consistent interface across different screen sizes.",

        "One of the main challenges was balancing large visual elements with the content structure while ensuring that the layout remained clean, functional, and visually consistent on both desktop and mobile.",
      ],
      image: "imgs/ProjectRecords/alpha-decor/hero.webp",
    },
    side: {
      Project: "Alpha Decor",
      LiveDemo: "/alpha-decor",
      Language: "Persian",
      Date: "August 2026",
      Technologies:
        "React · JavaScript · HTML · CSS · Responsive Design · Flexbox · CSS Grid",
    },
  },
};

export default alphaDecor;
